<template>
    <img src="@/assets/wordMark.svg" alt="Robin Westerhoff" height="168" width="168" class="logo">
</template>

<style lang="scss"></style>